import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navigation from '../navigation/navigationVisiteur';
import NavCoach from '../navigation/navCoach';
import PostAjoutCoach from './postAjoutCoach';



function PostCoach() {
    const Navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [type,setType] = useState(null)
    const apiUrl = process.env.REACT_APP_API_URL;


  
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          setIsLoading(true);
          const response = await axios.post(
            `${apiUrl}/verification/cookie`,
            {},
            {
              withCredentials: true // Permet de transmettre les cookies avec la requête
            }
          );
          setUserData(response.data);
          setError(null);
          setIsLoading(false);
          setType(response.data.user.type)
          if (response.data.user.type !== "coach") {
            Navigate('/connexion');
          }
  
        } catch (error) {
          setError(error.response.data.message);
          setIsLoading(false);
          Navigate('/connexion')

  
        }
      };
  
      fetchData(); 
    },[Navigate, apiUrl]);



    if (isLoading) {
      return (
      <div className="centered-content">
        <img src="/img/logo.png" alt="Logo" className="centered-logo" />
        <br/>
        <span className="loader"></span>
      </div>
      
      );  
    }





  return (
    
    <>
    {userData ? (
      <>
        <NavCoach userData={userData} nom='Post'/>
        <PostAjoutCoach userData={userData} type={type}/>
      </>
          ) : (
            <>
            <Navigation/>        
            <div id="alert-message" className="alert" >
                <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
            </div>
            </>
          )}
    </>
  );
}

export default PostCoach;
